import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputAuto, InputDate, Select } from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { Alert, Form } from "../../layout";
import InputMultFile from "../../controls/InputMultFile";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { NestedFormData, RmvEmptyProp } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditPayment = (props) => {
  const { PaymentMdl } = Model();
  const { t } = useTranslation();
  const [files] = useState([]);
  const { PayMethod } = DropLi();
  const navigate = useNavigate();
  const { branch, authUser } = useContext(AppContext);
  const [dueAmt, setDueAmt] = useState(0);
  const [members, setMembers] = useState([]);
  const [selInvs, setSelInvs] = useState([]);
  const [invs, setInvs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    handleFile,
  } = UseForm(PaymentMdl);

  useEffect(() => {
    if (branch && branch.id) {
      API(endpoints.Member + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setMembers([
            ...res.result.map((j) => ({
              ...j,
              label: j.firstName + " " + j.lastName,
              subtitle: `${t("MemberId")}: ${j.memberId}`,
            })),
          ])
      );
      API(endpoints.Invoice + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setInvs([
            ...res.result
              .filter((j) => j.status !== 2)
              .map((j) => ({
                ...j,
                id: j.id,
                label: j.title,
                subtitle: `${t("Due")}: ${
                  parseFloat(j.amount) - parseFloat(j.paidAmt || 0)
                } ${branch && branch.currency}`,
              })),
          ])
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    setSelInvs([
      ...invs.filter((j) => j.memberId === values.memberId && j.status !== 2),
    ]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.memberId, invs]);

  useEffect(() => {
    if (values.invId) {
      var _inv = selInvs.find((j) => j.id === values.invId);
      if (_inv) {
        var due = (
          parseFloat(_inv.amount) - parseFloat(_inv.paidAmt || 0)
        ).toFixed(2);
        setValues((x) => ({ ...x, amt: due }));
        setDueAmt(due);
      }
    } else {
      setValues((x) => ({ ...x, amt: "" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.invId]);

  const handleMember = (e) => {
    values.invId = "";
    handleInpChg(e);
  };

  const validateForm = () => {
    let temp = {};
    temp.memberId = values.memberId !== "" ? "" : t("ValMember");
    temp.amt = values.amt !== "" ? "" : t("ValAmount");
    temp.method = values.method !== "" ? "" : t("ValPaymentMethod");
    temp.payDate = values.payDate !== "" ? "" : t("ValPaymentDate");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && res.status === 201) {
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: t("PaymentSuccessTitle"),
            onClick: () => navigate("/payments"),
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.Payment + actions.Post).post(
          NestedFormData(RmvEmptyProp(values), "files"),
          onComplete
        );
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {t("AddPayment")}
              </h1>
            </div>

            <div>
              <Button loading={loading} type="submit">
                (t{"PayNow"})
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15 mt-30">
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <InputAuto
                  label={t("Member")}
                  name="memberId"
                  required={true}
                  value={values.memberId}
                  error={errors.memberId}
                  onChange={handleMember}
                  options={members}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputAuto
                  label={t("Invoice")}
                  name="invId"
                  value={values.invId}
                  error={errors.invId}
                  onChange={handleInpChg}
                  disabled={selInvs.length ? false : true}
                  options={selInvs}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("Amount")}
                  name="amt"
                  type="number"
                  required={true}
                  value={values.amt}
                  error={errors.amt}
                  disabled={values.invId ? false : true}
                  onInput={(e) =>
                    parseFloat(e.target.value) > dueAmt
                      ? (e.target.value = values.amt)
                      : e
                  }
                  onChange={handleInpChg}
                />
                <span className="gray-color fs-12">
                  {t("DueAmount")}: {dueAmt} {branch && branch.currency}
                </span>
              </Grid>

              <Grid item xs={12} md={4}>
                <Select
                  label={t("PaymentMethod")}
                  name="method"
                  required={true}
                  value={values.method}
                  error={errors.method}
                  onChange={handleInpChg}
                  options={PayMethod}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("ReferenceNo")}
                  name="refe"
                  value={values.refe}
                  error={errors.refe}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputDate
                  label={t("PayDate")}
                  name="payDate"
                  required={true}
                  value={values.payDate}
                  error={errors.payDate}
                  onChange={(date) =>
                    handleInpDate(
                      "payDate",
                      new Date(date).toLocaleDateString()
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Input
                  label={t("Note")}
                  name="note"
                  inputProps={{ maxLength: 600 }}
                  value={values.note}
                  error={errors.note}
                  onChange={handleInpChg}
                  multiline
                  rows={2}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputMultFile
                  label={t("UploadFile")}
                  name="files"
                  maxSize={6}
                  src={files}
                  values={values.files}
                  onChange={handleFile}
                  rmv={(file) => {
                    setValues((x) => ({
                      ...x,
                      files: x.files.filter(
                        (j) => j.lastModified !== file.lastModified
                      ),
                      paymentFiles: x.paymentFiles.filter(
                        (j) => j.id !== file.id
                      ),
                    }));
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditPayment;
